module.exports = __webpack_public_path__ + "img/back3.26a2e3ee.png";